import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import {createRouter} from './router'
import {createStore} from './store'
import Vuetify from 'vuetify'
import 'babel-polyfill'
import Numerate from '@/plugins/numerate'

// Helpers
import colors from 'vuetify/es5/util/colors'

const router = createRouter()
const store = createStore()

Vue.config.productionTip = false

Numerate(Vue)

Vue.use(VueResource)
// https://vuetifyjs.com/en/style/colors
Vue.use(Vuetify, {
    theme: {
        primary: colors.blue.darken1,
        secondary: colors.blue.lighten4,
        accent: colors.indigo.base
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
